import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, switchMap, map, take } from 'rxjs/operators';
import { WINDOW, WindowWrapper } from '../../common/index';
import { GaSessionConfigService } from './../services/session.config.service';
import { GaSessionService } from './../services/session.service';

@Injectable()
export class SessionInterceptor implements HttpInterceptor {
    constructor(
        private sessionConfig: GaSessionConfigService,
        private sessionService: GaSessionService,
        @Inject(WINDOW) private window: WindowWrapper,
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.sessionConfig.enabled || !req.url.startsWith(this.sessionConfig.serverUrl)) { return next.handle(req); }
        return this.sessionService.sessionUser$.pipe(
            take(1),
            map(session => {
                const sesionId = session ? session.id : null;

                // Clone the request and replace the original headers with
                // cloned headers, updated with the authorization.
                let newHeader = req.headers;
                if (!newHeader.has('content-type') && !(req.body && req.body.constructor && req.body.constructor.name === 'FormData')) {
                    newHeader = req.headers.set('content-type', 'application/json');
                }
                if (sesionId && !req.headers.get('x-session-id')) { newHeader = req.headers.set('x-session-id', sesionId); }

                const authReq = req.clone({
                    headers: newHeader
                });
                return authReq;
            }),
            switchMap(authReq => next.handle(authReq).pipe(
                catchError(error => {
                    // UNAUTHORIZED
                    if (error && error.status === 401) {
                        this.window.location.href = this.window.location.origin +
                            this.sessionConfig.unautorizedUrl +
                            '?from=' +
                            encodeURIComponent(this.window.location.href);
                        return of(null);
                    }
                    return throwError(error);
                })
            ))
        );
    }
}

export const sessionInterceptorProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: SessionInterceptor,
    multi: true,
};
